<template>
  <div>
    <div class="air__utils__heading">
      <div class="row">
        <div class="col-6 col-sm-8">
          <h5>Final Result Settings</h5>
        </div>
        <div class="col-6 col-sm-4 text-right">
          <!-- <add-exam-setup @created="handleCreated"/> -->
        </div>
      </div>
    </div>

    <div class="row justify-content-center">
      <div class="col-xl-12">
        <div class="row">
          <!-- Session Select -->
          <div class="col-md-2 col-12 mb-2">
            <a-select
              size="default"
              v-model="selectedSession"
              optionFilterProp="children"
              style="width: 100%"
              @change="handleSessionChange"
              :filterOption="false"
              :defaultValue="currentSession ? currentSession.id : ''"
            >
            <template v-for="schoolSession in schoolSessions">
              <a-select-option :value="schoolSession.id" :key="schoolSession.id">
                  {{schoolSession.name}}
                  <small class="text-primary ml-2">{{ currentSession.id === schoolSession.id ? 'Current' : '' }}</small>
              </a-select-option>
            </template>
            </a-select>
          </div>
        </div>
        <div class="card">
          <div class="card-body">
            <final-result-list-table :data="data" :loading="loading" :session="selectedSession" @updateTable="handleUpdateTable" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { find } from 'lodash'

import FinalResultListTable from '@/components/bosemexam/final/Table/index'
// import AddExamSetup from '@/components/exam/final/Forms/Add/index'

export default {
  components: {
    FinalResultListTable,
    // AddExamSetup,
  },
  mounted: function() {
    window.Echo.private('FinalExam.' + this.user.user.id)
      .listen('.FinalDeclared', (e) => {
        this.handleUpdateTable()
      })
    this.$http.get('/api/session')
      .then(({ data }) => {
        this.schoolSessions = data.data
        this.selectedSession = find(data.data, ['is_current', 1]).id
      })
      .catch(error => {
        this.$neoNotify.error(error)
      })
    this.getFinalResultSettings()
  },
  destroyed: function () {
    window.Echo.leave('FinalExam.' + this.user.user.id)
  },
  computed: {
    ...mapState(['user']),
    currentSession: function() {
      const session = find(this.schoolSessions, ['is_current', 1])
      return session
    },
  },
  watch: {
    currentSession: function (val) {
      this.selectedSession = val.id
    },
  },
  data: function() {
    return {
      loading: false,
      visible: false,
      selectedSession: undefined,
      schoolSessions: [],
      data: [],
    }
  },
  methods: {
    getFinalResultSettings: function() {
      this.loading = true
      this.$http.get('/api/finalresultsetting', {
        params: {
          session_id: this.selectedSession,
        },
      }).then(({ data }) => {
        this.loading = false
        this.data = data.data
      })
    },
    handleCreated: function() {
      this.getFinalResultSettings()
    },
    handleUpdateTable: function() {
      this.getFinalResultSettings()
    },
    handleSessionChange (value) {
      this.data = []
      if (value) {
        this.selectedSession = value
      } else {
        this.selectedSession = this.currentSession
      }
      this.getFinalResultSettings()
    },
  },
}
</script>
